export default defineNuxtRouteMiddleware((to, from) => {
	console.log(to.params._id);
});
